@if (assessmentsLoaded) {
  @if (activityRecord.can_comment || assessments.length > 0) {
    <div class="box-comment">
      @if (canCreateAssessment()) {
        <app-assessment-form-teacher [activityRecordId]="activityRecord.id" (saveNewAssessment)="onsaveNewAssessment($event)">
        </app-assessment-form-teacher>
      }
      @for (assessment of assessments; track assessment.id) {
        @switch (assessment !== edittingAssessment) {
          @case (true) {
            <app-assessment-detail-teacher
              [assessment]="assessment"
              [canEdit]="canEditAssessment(assessment)"
              (editAssessment)="onEditAssessment(assessment)"
            >
            </app-assessment-detail-teacher>
          }
          @case (false) {
            <app-assessment-form-teacher
              [activityRecordId]="activityRecord.id"
              [assessment]="assessment"
              (cancelEditAssessment)="onCancelEditAssessment()"
              (updateOldAssessment)="onUpdateOldAssessment($event, assessment)"
              (deleteOldAssessment)="onDeleteOldAssessment(assessment)"
            >
            </app-assessment-form-teacher>
          }
        }
      }
      @if (canLoadMore) {
        <div class="load-more">
          <a class="spen-util-link" (click)="loadMoreAssessments()">
            <span>もっと見る</span>
            <i [class]="isLoadingMore ? 'fa fa-spinner fa-spin' : 'fa fa-chevron-down'"></i>
          </a>
        </div>
      }
    </div>
  }
  @if (assessments.length === 0) {
    <div class="empty-message">ここに先生のコメントが表示されます。</div>
  }
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}

@if (!activityRecord.can_comment && assessments?.length > 0) {
  <p class="permission-message">※課題配信先のスペースを担当していないためコメントできません。</p>
}
